module.exports = __webpack_public_path__ + "img/logo.abb9c205.png";